<template>
	<v-overlay
		v-if="ui.show"
		:z-index="55"
		:opacity="0.6"
		:class="[
			'cart-container',
			'animate__animated',
			'animate__faster',
			ui.animations.overlay,
		]"
	>
		<div class="inshadow" @click="toggle()"></div>

		<div
			:class="[
				'cart-content',
				'elevation-5',
				'animate__animated',
				ui.animations.content,
			]"
		>
			<div class="articles-container">
				<v-container fluid class="pt-0 pb-0">
					<v-row justify="end">
						<v-col
							cols="12"
							class="pt-2 pb-2 d-flex align-center justify-space-between pr-3"
						>
							<div class="d-flex flex-column justify-center">
								<h2>
									Carrito de compra
								</h2>

								<small class="ma-0 ml-1">
									{{ `${articles.length} artículos.` }}
								</small>
							</div>

							<v-btn
								fab
								color="#eee"
								@click="toggle()"
								class="elevation-1 black--text ma-0 animate__animated animate__rotateIn elevation-0"
							>
								<v-icon>
									mdi-close
								</v-icon>
							</v-btn>
						</v-col>

						<v-col
							cols="12"
							class="pt-0 article"
							v-for="(article, key) in articles"
							@click="open(article)"
						>
							<v-row justify="end">
								<v-col
									cols="3"
									md="3"
									class="d-flex align-center justify-center"
									style="position: relative;"
								>
									<small class="counter">
										{{ key + 1 }}
									</small>

									<template v-if="mainImage(article)">
										<img :src="mainImage(article)" alt="" />
									</template>

									<template v-else>
										<div
											class="no-image no-image-small"
										></div>
									</template>
								</v-col>

								<v-col
									cols="9"
									md="9"
									class="d-flex flex-column justify-center"
								>
									<small>
										{{
											`${article.description} (${article.code})`
										}}
									</small>

									<div class="d-flex align-center">
										<small>
											P.U:
											<span>
												{{
													`${priceFormat(
														article.price
													)} MXN`
												}}
											</span>
										</small>

										<small class="ml-3">
											Cantidad:
											<span>
												{{ article.amount }}
											</span>
										</small>
									</div>

									<!-- ArticleColor Component -->
									<ArticleColor
										:article="article"
									></ArticleColor>
								</v-col>
							</v-row>
						</v-col>

						<v-col cols="12" class="cart-footer">
							<div class="d-flex flex-column">
								<div class="mb-5">
									Total:
									<strong class="ml-2">
										{{ `${Total} MXN` }}
									</strong>
								</div>

								<div>
									<v-btn
										block
										color="primary"
										class="white--text"
										large
										@click="cartShow()"
									>
										Ver todo
									</v-btn>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>
	</v-overlay>
</template>

<script>
import { EventBus } from "@/main";
import Article from "@/clas/Article";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import ArticleColor from "@/components/Article/Color";

export default {
	name: "CartTypePanel",

	components: { ArticleColor },

	data() {
		return {
			ui: {
				show: false,
				animations: {
					overlay: "animate__fadeIn",
					content: "animate__slideInRight",
				},
			},
		};
	},

	created() {
		EventBus.$on("CartTypePanelToggle", () => {
			this.toggle();
		});
	},

	methods: {
		cartShow() {
			this.toggle();

			if (this.$route.name != "CartShow") {
				this.$router.push({ name: "CartShow" });
			}
		},

		priceFormat(val) {
			let a = new Article();

			return a.priceFormat(val);
		},

		mainImage(article) {
			let a = new Article(article);

			return a.mainImage();
		},

		toggle() {
			if (this.ui.show) {
				this.ui.animations = {
					overlay: "animate__fadeOut",
					content: "animate__slideOutRight",
				};

				setTimeout(() => {
					this.ui.show = !this.ui.show;

					this.ui.animations = {
						overlay: "animate__fadeIn",
						content: "animate__slideInRight",
					};
				}, 300);
			} else {
				this.ui.show = !this.ui.show;
			}

			EventBus.$emit("AppOverflowToggle", this.ui.show);
		},

		open(article) {
			this.toggle();

			this.$router.push({
				name: "PrductShow",
				params: {
					id: article.product_id,
				},
			});
		},
	},

	computed: {
		...mapGetters({
			getArticles: "cart/getArticles",
			getTotal: "cart/getTotal",
		}),

		articles() {
			return this.getArticles;
		},

		Total() {
			return this.priceFormat(this.getTotal);
		},

		hasArticles() {
			return this.articles.length > 0 ? true : false;
		},

		showButtonViewMore() {
			if (
				this.$vuetify.breakpoint.smAndDown &&
				this.articles.length >= 4
			) {
				return true;
			}

			if (this.$vuetify.breakpoint.mdAndUp && this.articles.length >= 5) {
				return true;
			}

			return false;
		},
	},
};
</script>

<style lang="css" scoped>
.cart-content {
	right: 0;
	top: 0;
	/*padding-left: 20px;*/
	z-index: 2;
	width: 35vw;
	height: 100vh;
	position: fixed;
	background-color: #fff;
	animation-duration: 0.3s;
}

.cart-content,
.cart-content > * {
	color: initial;
}
.inshadow {
	left: 0;
	top: 0;
	height: 100vh;
	width: 100vw;
}

.articles-container {
	width: 100%;
	height: 100%;
	/*overflow-y: scroll;*/
}

.cart-footer {
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	width: 100%;
	bottom: 0;
	padding-left: 20px;
	height: 40%;
	background: linear-gradient(
		0deg,
		rgba(255, 255, 255, 1) 30%,
		rgba(0, 0, 0, 0) 100%
	);
}

.cart-footer > div {
	width: 100%;
}

img {
	height: 75px;
	width: auto;
}

.article {
	border-bottom: 1px solid #eee;
}

.article:hover {
	cursor: pointer;
	background: linear-gradient(
		60deg,
		rgba(2, 0, 36, 0) 0%,
		rgba(0, 0, 0, 0.1) 100%
	);
}

.counter {
	position: absolute;
	left: 15px;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 960px) {
	.cart-content {
		width: 75vw;
	}

	.counter {
		left: 10px;
	}

	.cart-footer {
		height: 30%;
	}
}
</style>
